// types
import { Article } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { Link } from 'react-router-dom';

// mui
import { Box, Grid, Paper, Typography } from '@mui/material';

// ui
import { Time } from '../../../ui/Time/Time';

// theme
import { theme } from '../../../../theme';

// props
export interface SidebarProps {
	activeId?: string;
	articles: Article[];
}

export const Sidebar = ({ activeId, articles }: SidebarProps) => {
	// hooks
	const { t } = useTranslation();

	return (
		<Paper sx={{ height: '100%', width: '100%' }}>
			<Box sx={(theme) => ({ padding: theme.spacing(2) })}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography fontWeight={700}>{t('releaseHistory')}</Typography>
					</Grid>
					<Grid item xs={12}>
						<Grid container spacing={2}>
							{articles.map((article, i) => {
								const isActive = activeId === article.id;
								return (
									<Grid item key={`sidebar-article-${i}`} xs={12}>
										<Box
											component={Link}
											onClick={() => {
												// scroll to top of page
												window.scrollTo({
													top: 0,
													behavior: 'smooth',
												});
											}}
											sx={{
												transition: 'all 200ms ease',
												backgroundColor: isActive ? theme.palette.grey[100] : 'transparent',
												borderColor: theme.palette.divider,
												borderWidth: 1,
												borderRadius: 2,
												borderStyle: 'solid',
												padding: theme.spacing(2),
												display: 'block',
												width: '100%',
												textDecoration: 'none',
												'&:hover': {
													backgroundColor: theme.palette.grey[100],
												},
											}}
											to={`/features/${article.id}`}>
											<Typography color="brand.blue.400" fontWeight={800} variant="caption">
												{article.release}
											</Typography>
											<div>
												<Typography fontWeight={600} variant="body2">
													{article.title}
												</Typography>
											</div>
											<Time date={article.date} TypographyProps={{ variant: 'caption' }} />
										</Box>
									</Grid>
								);
							})}
						</Grid>
					</Grid>
				</Grid>
			</Box>
		</Paper>
	);
};
